"use client";
import React, { useEffect, useMemo, useState } from "react";
import PropTypes from "prop-types";
import { Input } from "atm-global-stylish/dist";

const digitsOnly = (v = "") => (v || "").replace(/\D+/g, "");
const validateParts = (area, telefono) => {
  const a = digitsOnly(area);
  const t = digitsOnly(telefono);
  if (!a && !t) return false;
  if (!a || !t) return false;
  if (a.length > 4) return false;
  if (t.length > 8) return false;
  if (a.startsWith("0")) return false;
  if (a.length === 2 && a !== "11") return false;
  if (a.length + t.length !== 10) return false;
  return true;
};

const PhoneInput = ({ handleChange, className, prefix }) => {
  const [dataPerson, setDataPerson] = useState({ area: "", telefono: "" });

  const isValid = useMemo(
    () => validateParts(dataPerson.area, dataPerson.telefono),
    [dataPerson.area, dataPerson.telefono]
  );

  useEffect(() => {

    handleChange(`${prefix}phone_area`)({ target: { value: dataPerson.area } });
    handleChange(`${prefix}phone_number`)({ target: { value: dataPerson.telefono } });


    if (isValid) {
      const full = `${digitsOnly(dataPerson.area)}${digitsOnly(dataPerson.telefono)}`;
      handleChange(`${prefix}phone`)({ target: { value: full } });
    } else {
      handleChange(`${prefix}phone`)({ target: { value: "" } });
    }

  }, [isValid, dataPerson.area, dataPerson.telefono]);

  return (
    <div className="grid grid-cols-12 gap-2 w-full">
      <div className="col-span-4 md:col-span-3">
        <Input
          placeholder="Cod. Área *"
          value={dataPerson.area}
          handleChange={(e) => {
            if (dataPerson.area.length === 0 && e.target.value === '0') {
              return;
            }
            
            const next = digitsOnly(e.target.value).slice(0, 4);
            setDataPerson((prev) => ({ ...prev, area: next }));
          }}
          className={className}
          type="number"
        />
      </div>

      <div className="col-span-8 md:col-span-9">
        <Input
          placeholder="Teléfono (sin 15) *"
          value={dataPerson.telefono}
          handleChange={(e) => {
            const next = digitsOnly(e.target.value).slice(0, 8);
            setDataPerson((prev) => ({ ...prev, telefono: next }));
          }}
          className={className}
          type="number"
        />
      </div>
    </div>
  );
};

PhoneInput.propTypes = {
  handleChange: PropTypes.func.isRequired,
  className: PropTypes.string,
};

export default PhoneInput;
